import { render, staticRenderFns } from "./StandingOrders.vue?vue&type=template&id=a0286054&scoped=true&"
import script from "./StandingOrders.vue?vue&type=script&lang=js&"
export * from "./StandingOrders.vue?vue&type=script&lang=js&"
import style0 from "./StandingOrders.vue?vue&type=style&index=0&id=a0286054&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0286054",
  null
  
)

export default component.exports